/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson } from '../lib/api.js';
import { MAINTAINER_ID, PB_URL } from '../lib/config.js';
import { playBlip, playPop } from '../lib/sound.js';

export default {
  // Berichten staan in het postvakje als "Krabbelpaal XP", dus alleen de mod stuurt ze.
  openDmPicker() { return this.isMaintainer ? this.setState({ dialog: 'dm', dmTo: null, dmText: '', dmError: '' }) : undefined; },

  openDm(acc) { return this.setState({ dialog: 'dm', dmTo: acc, dmText: '', dmError: '' }); },

  openBroadcast() { return this.setState({ dialog: 'dm', dmTo: { id: '*', name: 'Iedereen' }, dmText: '', dmError: '' }); },

  dmBackToPicker() { return this.setState({ dmTo: null, dmError: '' }); },

  closeDm() { return this.setState({ dialog: 'account', dmTo: null, dmText: '' }); },

  onDmInput(e) { return this.setState({ dmText: e.target.value }); },

  async sendDm() {
      const text = (this.state.dmText || '').trim();
      const to = this.state.dmTo;
      if (!to || !this.isMaintainer) return;
      if (!text) { this.setState({ dmError: 'Schrijf eerst een bericht.' }); return; }
      this.setState({ dmSending: true, dmError: '' });
      if (to.id === '*') {
        if (!this.isMaintainer) { this.setState({ dmSending: false }); return; }
        const targets = (this.state.accounts || []).filter((a) => a.id);
        const results = await Promise.all(targets.map((a) => api(`${PB_URL}/api/collections/paal_dm/records`, asJson('POST', { toId: a.id, fromId: this.state.accountId || '', text, seen: false })).then((r) => r.ok).catch(() => false)));
        const ok = results.filter(Boolean).length;
        if (!ok) { this.setState({ dmSending: false, dmError: 'Versturen mislukt. Probeer het nog eens.' }); return; }
        this.setState({ dmSending: false, dialog: 'account', dmTo: null, dmText: '' });
        playPop();
        this.notify('Bericht verstuurd naar ' + ok + ' krabbelaar' + (ok === 1 ? '' : 's') + '.');
        return;
      }
      try {
        const res = await api(`${PB_URL}/api/collections/paal_dm/records`, asJson('POST', { toId: to.id, fromId: this.state.accountId || '', text, seen: false }));
        if (!res.ok) throw new Error(res.status === 404 ? 'missing' : String(res.status));
        // De afzender krijgt zijn eigen paalbericht ook te zien.
        if (this.state.accountId && to.id !== this.state.accountId) {
          api(`${PB_URL}/api/collections/paal_dm/records`, asJson('POST', { toId: this.state.accountId, fromId: this.state.accountId, text, seen: false })).catch(() => {});
        }
        this.setState({ dmSending: false, dialog: 'account', dmTo: null, dmText: '' });
        playPop();
      } catch (e) {
        this.setState({
          dmSending: false,
          dmError: e.message === 'missing'
            ? 'Maak op de server de collectie paal_dm aan met velden toId, fromId, text (tekst) en seen (boolean).'
            : 'Versturen mislukt. Probeer het nog eens.'
        });
      }
    },

  async fetchDms() {
      const me = this.state.accountId;
      if (!me) return;
      try {
        const filter = encodeURIComponent(`toId="${me}" && seen=false`);
        const res = await api(`${PB_URL}/api/collections/paal_dm/records?filter=${filter}&sort=created&perPage=20`);
        if (!res.ok) return;
        const data = await res.json();
        // Intussen van account gewisseld: dit zijn de berichten van de vorige.
        if (me !== this.state.accountId) return;
        // Het postvakje toont elk bericht als "Krabbelpaal XP". De collectie staat
        // open, dus alleen wat de mod stuurde mag er onder die naam in.
        const inbox = (data.items || []).filter((r) => r.fromId === MAINTAINER_ID)
          .map((r) => ({ id: r.id, fromId: r.fromId || '', text: r.text || '', created: r.created || '' }));
        const changed = inbox.length !== (this.state.dmInbox || []).length;
        this.setState({ dmInbox: inbox });
        if (changed && inbox.length) playBlip();
      } catch (e) {}
    },

  async dismissDm() {
      const inbox = this.state.dmInbox || [];
      const cur = inbox[0];
      if (!cur) return;
      this.setState({ dmInbox: inbox.slice(1) });
      try {
        await api(`${PB_URL}/api/collections/paal_dm/records/${cur.id}`, asJson('PATCH', { seen: true }));
      } catch (e) {}
    }
};
